import { Link } from "react-router-dom";

const SiteFooter = () => (
  <footer className="relative border-t border-white/5 bg-vortex-surface/30" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <img
            src="/brand/logo-light.360w.8d5f5d91.webp"
            width={360}
            height={101}
            alt="Vortex Vending Services LLC"
            className="h-14 w-auto sm:h-16"
            data-testid="footer-logo"
          />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Modern Vending for a Modern World. Smart coolers, stocked and spotless,
            backed by communication that actually answers.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs tracking-[0.25em] text-slate-500 uppercase">Pages</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link data-testid="footer-link-home" to="/" className="text-slate-300 transition-colors hover:text-vortex-cyan">Home</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="text-slate-300 transition-colors hover:text-vortex-cyan">About Us</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="text-slate-300 transition-colors hover:text-vortex-cyan">Contact Us</Link></li>
            <li><Link data-testid="footer-link-feedback" to="/feedback" className="text-slate-300 transition-colors hover:text-vortex-cyan">Customer Feedback</Link></li>
            <li><Link data-testid="footer-link-areas" to="/service-area" className="text-slate-300 transition-colors hover:text-vortex-cyan">Service Area</Link></li>
            <li><Link data-testid="footer-link-office" to="/office-vending" className="text-slate-300 transition-colors hover:text-vortex-cyan">Office Vending</Link></li>
            <li><Link data-testid="footer-link-apartment" to="/apartment-building-vending" className="text-slate-300 transition-colors hover:text-vortex-cyan">Apartment Building Vending</Link></li>
            <li><Link data-testid="footer-link-medical" to="/medical-office-vending" className="text-slate-300 transition-colors hover:text-vortex-cyan">Medical Office Vending</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs tracking-[0.25em] text-slate-500 uppercase">Reach Us</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a data-testid="footer-email-link" href="mailto:info@vortexvs.com" className="text-slate-300 transition-colors hover:text-vortex-cyan">
                info@vortexvs.com
              </a>
            </li>
            <li>
              <a data-testid="footer-phone-link" href="tel:+16109838060" className="text-slate-300 transition-colors hover:text-vortex-cyan">
                (610) 983-8060
              </a>
            </li>
            <li className="text-slate-500">Replies within one business day</li>
            <li className="text-slate-500">Serving the western Philadelphia suburbs</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t border-white/5 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-[11px] tracking-[0.2em] text-slate-600 uppercase">
          {`© ${new Date().getFullYear()} Vortex Vending Services LLC`}
        </p>
        <p className="font-mono text-[11px] tracking-[0.2em] text-slate-600 uppercase">
          Modern Vending for a Modern World
        </p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
